import { AlertTemplate } from "./types";

/**
 * MOCK templates until the backend serves them (GET /alert-templates). Each school (tenant) will have
 * its own DLT-approved templates in the DB; the ids here are placeholders.
 */
export const MOCK_ALERT_TEMPLATES: AlertTemplate[] = [
  {
    id: "MOCK_HOLIDAY_1",
    type: "HOLIDAY",
    name: "Holiday",
    allowAll: true,
    body: "Dear Parent, the school will remain closed on {date} on account of {reason}. Classes resume on {resumeDate}. - {school}",
    variables: [
      { key: "date", label: "Holiday date", source: "user", kind: "date" },
      { key: "reason", label: "Reason", source: "user", kind: "text", maxLength: 30 },
      { key: "resumeDate", label: "Resume date", source: "user", kind: "date" },
      { key: "school", label: "school name", source: "system" },
    ],
  },
  {
    id: "MOCK_EVENT_1",
    type: "EVENT",
    name: "Event",
    allowAll: true,
    body: "Dear Parent, you are invited to {eventName} on {date} at {time}, {venue}. - {school}",
    variables: [
      { key: "eventName", label: "Event", source: "user", kind: "text", maxLength: 30 },
      { key: "date", label: "Date", source: "user", kind: "date" },
      { key: "time", label: "Time", source: "user", kind: "time" },
      { key: "venue", label: "Venue", source: "user", kind: "text", maxLength: 30 },
      { key: "school", label: "school name", source: "system" },
    ],
  },
  {
    id: "MOCK_FEE_REMINDER_1",
    type: "FEE_REMINDER",
    name: "Fee reminder",
    allowAll: false,
    onlyWithDues: true,
    // every variable is filled by the backend per student; the admin only picks the class
    body: "Dear Parent, fee of Rs.{amount} for {studentName} is pending up to Term {term}. Kindly pay at the earliest. - {school}",
    variables: [
      { key: "amount", label: "amount due", source: "system" },
      { key: "studentName", label: "student name", source: "system" },
      { key: "term", label: "term", source: "system" },
      { key: "school", label: "school name", source: "system" },
    ],
  },
];

/** Will become GET /alert-templates (per tenant). */
export const getAlertTemplates = async (): Promise<AlertTemplate[]> => MOCK_ALERT_TEMPLATES;
